/**
 * TierBadge — MCP server tier badge
 * Used across: MCP Servers, Health Monitor, Detail
 */

import { Shield, Server, Zap } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { McpTier } from '@/lib/mock-connections-data';

export const TIER_BADGE_STYLES: Record<McpTier, string> = {
  tier1: 'border-blue-500/30 text-blue-600 dark:text-blue-400',
  tier2: 'border-purple-500/30 text-purple-600 dark:text-purple-400',
  tier3: 'border-orange-500/30 text-orange-600 dark:text-orange-400',
};

export const TIER_ICONS: Record<McpTier, typeof Server> = {
  tier1: Shield,
  tier2: Server,
  tier3: Zap,
};

const TIER_SHORT_LABELS: Record<McpTier, string> = {
  tier1: 'Tier 1',
  tier2: 'Tier 2',
  tier3: 'Tier 3',
};

interface TierBadgeProps {
  tier: McpTier;
  className?: string;
}

export function TierBadge({ tier, className }: TierBadgeProps) {
  return (
    <Badge variant="outline" className={cn('text-[9px]', TIER_BADGE_STYLES[tier], className)}>
      {TIER_SHORT_LABELS[tier]}
    </Badge>
  );
}
